import React from "react";
import {DotLottieReact} from "@lottiefiles/dotlottie-react";

const STATUS_ASSET = {
    running: "focused.lottie",
    paused: "paused.lottie",
    free: "free.lottie",
};

export function focusStatusLottieSource(status) {
    const filename = STATUS_ASSET[status] || STATUS_ASSET.free;
    return `${process.env.PUBLIC_URL || ""}/${filename}`;
}

function FocusStatusLottie({status = "free", label, className = ""}) {
    return (
        <div role="img" aria-label={label} data-focus-status={status || "free"}
            className={`flex align-items-center justify-content-center overflow-hidden flex-none ${className}`}>
            <DotLottieReact
                src={focusStatusLottieSource(status)}
                autoplay
                loop
                className="w-full h-full"
            />
        </div>
    );
}

export default FocusStatusLottie;
